//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import request from '@/api/request';
import { approveApplyEditApi, approveApplyFormApi, approveApplyListApi, attendanceAbnormalDateApi, attendanceAbnormalRecordApi, approveHolidayTypeSelectApi } from '@/api/business';
export default {
  components: {
    processFrom: function processFrom() {
      return import('./process');
    }
  },
  props: {
    parameterData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    typeNum: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    var _this = this;
    return {
      drawer: false,
      direction: 'rtl',
      fapi: null,
      abnormal: '',
      //异常日期
      record: '',
      //异常记录
      holiday: '',
      //假期类型
      abnormal_id: '',
      //异常日期id
      record_id: 0,
      //异常记录id
      holiday_id: 0,
      abnormal_label: '',
      record_label: '',
      calculateType: '',
      option: {
        form: {
          labelWidth: '120px'
        },
        submitBtn: false,
        global: {
          frame: {
            props: {
              closeBtn: false,
              okBtn: false,
              onLoad: function onLoad(e) {
                e.fApi = _this.$refs.fc.$f;
              }
            }
          }
        }
      },
      // 表单配置
      rules: [],
      approveId: 0,
      configData: null,
      formData: {},
      isRequest: true,
      examineData: {},
      id: 0,
      isEdit: false,
      loading: false,
      editUser: false,
      // 审批人添加按钮
      approverDelete: true,
      copyerDelete: true,
      tryDateOptions: null,
      // 异常时间
      tryYiChangOptions: null,
      // 异常记录
      holidayTypeOptions: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.typeNum == 1) {
      this.holidayType();
      this.attendanceAbnormalDate();
    }
  },
  watch: {},
  methods: {
    handleClose: function handleClose() {
      this.id = 0;
      this.drawer = false;
    },
    close: function close() {
      this.drawer = false;
      this.id = 0;
    },
    openBox: function openBox(command, val, type) {
      this.configData = command;
      this.id = command.id ? command.id : command;
      this.approveId = this.configData.approve_id ? this.configData.approve_id : this.configData.id;
      if (!this.isEdit) {
        // 添加
        this.approveApply(this.id, val, type);
      } else {
        // 编辑
        this.approveApply(command.approve_id);
      }
    },
    // 获取表单配置
    approveApply: function approveApply(id, val, type) {
      var _this2 = this;
      approveApplyFormApi(id, this.parameterData).then(function (res) {
        _this2.configData = res.data.info;
        res.data.forms.forEach(function (item) {
          if ((item.type === 'moneyFrom' || item.type === 'inputNumber') && item.props) {
            if (item.props.max) {
              item.props.max = Number(item.props.max);
            }
            if (item.props.min) {
              item.props.min = Number(item.props.min);
            }
            if (item.props.precision) {
              item.props.precision = Number(item.props.precision);
            }
          }
          if (item.children) {
            item.children.forEach(function (it) {
              if (it.title == '异常日期') {
                _this2.abnormal = it.field;
              }
              if (it.title == '异常记录') {
                _this2.record = it.field;
              }
            });
          }
        });
        _this2.rules = [];
        res.data.forms.map(function (item) {
          if (item.children && item.type !== 'span') {
            item.children.forEach(function (per) {
              if (per.calculateType) {
                per.calculateType = item.type;
                _this2.calculateType = item.type;
                if (per.title === '异常日期' && per.calculateType === 'refillFrom') {
                  per.options = _this2.tryDateOptions;
                }
                if (per.title === '假期类型' && per.calculateType === 'leaveFrom') {
                  per.options = _this2.holidayTypeOptions;
                }
                _this2.rules.push(per);
              } else {
                _this2.rules.push(per);
              }
            });
          } else {
            item.calculateType = item.type;
            _this2.rules.push(item);
          }
        });
        if (!_this2.isEdit) {
          _this2.drawer = true;
          _this2.$nextTick(function () {
            var data = _this2.handleFromObj();
            if (_this2.configData.examine == 0) return;
            _this2.approveApplyList(_this2.approveId, data);
          });
        } else {
          if (_this2.configData.examine == 0) return;
          _this2.approveApplyEdit(_this2.id, {
            types: 0
          });
        }
      });
    },
    // 获取人员配置表单
    approveApplyList: function approveApplyList(id, data) {
      var _this3 = this;
      approveApplyListApi(this.approveId || this.id, data).then(function (res) {
        _this3.examineData = res.data;
        var rules = res.data.rules;
        if (rules && rules.edit) {
          var rulesEdit = rules.edit + '';
          _this3.approverDelete = rulesEdit.includes('1');
          _this3.copyerDelete = rulesEdit.includes('2');
        }
        if (rules && rules.edit && rulesEdit.length > 0) {
          // 是否可删除审批人与抄送人
          if (_this3.examineData.list.length > 0) {
            _this3.examineData.list.map(function (value) {
              if (value.types == 1) {
                // 判断审批人是否为指定审批人
                if (rules.abnormal > 0 && (value.settype === 2 || value.settype === 7) && value.users.length <= 0) {
                  value.users.push(rules);
                }
                if (rulesEdit.includes('1')) {
                  value.users.map(function (val) {
                    val.isDelete = true;
                  });
                } else {
                  _this3.editUser = true;
                }
              }
              if (value.types == 2 && rulesEdit.includes('2')) {
                value.users.map(function (val) {
                  val.isDelete = true;
                });
              }
            });
          }
        } else {
          _this3.editUser = true;
        }
      });
    },
    holidayType: function holidayType() {
      var _this4 = this;
      approveHolidayTypeSelectApi().then(function (res) {
        _this4.holidayTypeOptions = res.data;
      });
    },
    handleChange: function handleChange(e) {
      var _this5 = this;
      // V1.4动态显示隐藏申请开票的邮寄字段
      var expressList = ['liaisonMan', 'telephone', 'mailingAddress'];
      var timeType;
      var data = this.handleFromObj();
      this.rules.forEach(function (it) {
        if (it.field === e && it.title == '假期类型' && _this5.holidayTypeOptions) {
          _this5.holidayTypeOptions.map(function (item) {
            if (item.value == data[e]) {
              timeType = item.duration_type;
            }
          });
        }
      });
      console.log(timeType);
      this.rules.forEach(function (item) {
        // console.log(item.type, !!JSON.stringify(timeType))
        if (data[e] == 'express') {
          if (expressList.includes(item.symbol)) {
            item.hidden = false;
          }
          if (item.symbol == 'invoicingEmail') {
            item.hidden = true;
          }
        } else if (data[e] == 'mail') {
          if (expressList.includes(item.symbol)) {
            item.hidden = true;
          }
          if (item.symbol == 'invoicingEmail') {
            item.hidden = false;
          }
        }
        if (_this5.fapi.rule[9] && _this5.fapi.rule[9].value == 1) {
          if (item.symbol == 'dutyParagraph') {
            item.hidden = true;
            item.effect.required = true;
          }
        } else {
          if (item.symbol == 'dutyParagraph') {
            item.hidden = false;
            item.effect.required = true;
          }
        }
        if (!!JSON.stringify(timeType) && item.type == 'timeFrom') {
          item.props.timeType = timeType == 0 ? 'day' : 'time';
        }
      });
      if (data[e] && data[e].timeType == 'time') {
        var dateStart = data[e].dateStart;
        var dateEnd = data[e].dateEnd;

        // 将日期时间字符串转换为 Date 对象
        var startDate = new Date(dateStart);
        var endDate = new Date(dateEnd);

        // 计算时间差
        var timeDifference = endDate - startDate;
        var millisecondsInHour = 60 * 60 * 1000;
        var hours = timeDifference / millisecondsInHour;
        data[e].duration = hours ? hours.toFixed(2) : '';
      }
      if (this.tryDateOptions) {
        this.tryDateOptions.map(function (item) {
          if (item.value == data[e]) {
            _this5.abnormal_label = item.label;
          }
        });
      }
      if (this.tryYiChangOptions) {
        this.tryYiChangOptions.map(function (item) {
          if (item.value == data[e]) {
            _this5.record_label = item.label;
          }
        });
      }
      var label;
      for (var i in data) {
        if (data[i] == data[e]) {
          label = i;
        }
        if (i == this.abnormal) {
          this.abnormal_id = data[i];
        }
        if (i == this.record) {
          this.record_id = data[i];
        }
        if (i == this.holiday) {
          this.holiday_id = data[i];
        }
      }
      // 赋值异常记录
      if (label == this.abnormal) {
        this.attendanceAbnormalRecord(data[e]);
      }
      if (!this.isEdit) {
        if (this.configData.examine == 0) return;
        this.approveApplyList(this.id, data);
      } else {
        if (this.configData.examine == 0) return;
        this.approveApplyList(this.configData.approve_id, data);
      }
    },
    // 递归回显审批内容
    calculateLevel: function calculateLevel(arr, option) {
      var _this6 = this;
      arr.forEach(function (value) {
        if (option[value.field]) {
          value.value = option[value.field];
        } else {
          _this6.calculateLevel(value.children, option);
        }
      });
      return arr;
    },
    // 编辑
    approveApplyEdit: function approveApplyEdit(id, data) {
      var _this7 = this;
      approveApplyEditApi(this.id, data).then(function (res) {
        _this7.drawer = true;
        var option = res.data;
        _this7.calculateLevel(_this7.rules, option);
        _this7.rules.forEach(function (item) {
          if (item.title == '异常日期') {
            _this7.attendanceAbnormalDate();
            if (item.value.abnormal_id) {
              _this7.abnormal_id = item.value.abnormal_id.value;
              _this7.abnormal_label = item.value.abnormal_id.label;
            }
            item.value = _this7.abnormal_label;
            _this7.attendanceAbnormalRecord(_this7.abnormal_id);
          }
        });
        var data = _this7.handleFromObj();
        _this7.approveApplyList(_this7.approveId, data);
      });
    },
    handleFromData: function handleFromData() {
      var attr = [];
      this.fapi.rule.map(function (item) {
        var condition = {};
        condition[item.field] = item.value ? item.value : '';
        attr.push(condition);
      });
      return attr;
    },
    handleFromObj: function handleFromObj() {
      var obj = {};
      var data = this.fapi ? this.fapi.rule : '';
      for (var i = 0; i < data.length; i++) {
        if (Object.prototype.toString.call(data[i].value) === '[object Object]') {
          data[i].value.type = data[i].calculateType;
        }
        var keys = data[i]['field'];
        obj[keys] = data[i].value ? data[i].value : '';
      }
      return obj;
    },
    // 提交
    handleConfirm: function handleConfirm() {
      var id = !this.isEdit ? this.id : this.approveId;
      this.approveApplySave(id);
    },
    // 保存
    approveApplySave: function approveApplySave(id) {
      var _this8 = this;
      var FromData = {
        title: this.$t('hr.addposition'),
        method: 'post',
        action: "approve/apply/save/".concat(id)
      };
      this.$refs.fc.$f.submit(function (formData) {
        Object.keys(formData).forEach(function (k) {
          if (formData[k] === undefined) formData[k] = '';
        });
        var processInfo = _this8.examineData.list;
        if (processInfo && processInfo.length && _this8.configData.examine != 0) {
          var len = 0;
          for (var i = 0; i < processInfo.length; i++) {
            var value = processInfo[i];
            if (!_this8.approverDelete && value.types == 1 && value.users.length <= 0) {
              _this8.$message.error('自选节点不能为空');
              return;
            }
            if (!_this8.copyerDelete && value.types == 2 && value.users.length <= 0) {
              _this8.$message.error('自选节点不能为空');
              return;
            }
            if (_this8.approverDelete && value.types == 1 && (value.settype == 4 || value.settype == 1) && value.users.length <= 0) {
              _this8.$message.error('自选节点不能为空');
              return;
            }
            if (value.users.length <= 0) {
              len++;
            }
          }
          if (len === processInfo.length) {
            _this8.$message.error('自选节点不能为空');
            return;
          }
          processInfo.forEach(function (value, index) {
            if (value.users.length <= 0) {
              processInfo.splice(index, 1);
            }
          });
        }
        var data = {
          formInfo: formData,
          processInfo: processInfo
        };
        if (_this8.isEdit) {
          data.apply_id = _this8.id;
        }
        _this8.loading = true;
        request[FromData.method.toLowerCase()](FromData.action, data).then(function (res) {
          _this8.loading = false;
          _this8.close();
          _this8.$emit('scheduleRecord');
          _this8.$emit('isOk');
        }).catch(function (err) {
          _this8.loading = false;
        });
      });
    },
    // 调用接口赋值 异常日期
    attendanceAbnormalDate: function attendanceAbnormalDate() {
      var _this9 = this;
      attendanceAbnormalDateApi().then(function (res) {
        if (res.status == 200) {
          _this9.tryDateOptions = res.data;
          _this9.tryDateOptions = _this9.tryDateOptions.map(function (it) {
            it.label = it.date;
            it.value = it.id;
            return it;
          });
        }
      });
    },
    // 异常记录
    attendanceAbnormalRecord: function attendanceAbnormalRecord(id) {
      var _this10 = this;
      attendanceAbnormalRecordApi(id).then(function (res) {
        if (res.status == 200) {
          _this10.tryYiChangOptions = res.data;
          _this10.tryYiChangOptions = _this10.tryYiChangOptions.map(function (it) {
            it.value = it.shift_number;
            it.label = it.title + ' : ' + it.time;
            return it;
          });
          // 赋值
          for (var i = 0; i < _this10.rules.length; i++) {
            if (_this10.rules[i].title === '异常记录' && _this10.rules[i].calculateType === 'refillFrom') {
              _this10.rules[i].options = _this10.tryYiChangOptions;
              break;
            }
          }
        }
      });
    }
  }
};